export const getAhrUrl = (url, isAhr) => {
  let result = isAhr ? "/ahr" : "";
  result += url;

  return result;
};

export default getAhrUrl;
